import { GenericInspectorPanelConfirmControls } from "../generics/GenericInspectorPanelConfirmControls"
import { GenericInspectorPanelFooterContainer } from "../inspector-panels/footers/GenericInspectorPanelFooter"
import { useCallback, useEffect } from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { setActiveTool } from "plugins/Toolbox/tool-registry"
import { clearEditingData, createNewMockLine } from "plugins/Toolbox/Line/LineSlice"
import { geometryDataStore } from "plugins/shared/layers/GeometryDataStore"

export const InspectorPanelLineMockedFooter = () => {
    const dispatch = useAppDispatch()

    const points = geometryDataStore.useGeometryData("points")

    const cancel = useCallback(() => {
        dispatch(setActiveTool(undefined))
    }, [dispatch])

    useEffect(() => {
        dispatch(createNewMockLine())
        return () => {
            geometryDataStore.free(false)
            dispatch(clearEditingData())
        }
    }, [dispatch])

    const confirm = useCallback(() => {
        geometryDataStore.free(true)
    }, [])

    return (
        <GenericInspectorPanelFooterContainer>
            <GenericInspectorPanelConfirmControls
                onCancel={cancel}
                onConfirm={confirm}
                canConfirm={points.length >= 2}
            />
        </GenericInspectorPanelFooterContainer>
    )
}
